import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class ApplicationStatusService {
  getAll() {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/applicationStatus`, options);
  }
}

export default ApplicationStatusService;
